import React from 'react';

const TriggerDetails = ({ item }) => {
  return (
    <div className="relative flex flex-col gap-2 rounded-md border border-zinc-700 bg-zinc-800 px-4 py-3 transition-colors duration-150 ease-in-out">
      <div className="mb-5 flex items-center gap-2">
        <div className="flex items-center gap-1">
          <div className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded border border-zinc-300 bg-zinc-100 p-0.5">
            <img
              src={'https://oqlous.inqbator.in/assets/oqlous.svg'}
              alt="Trigger icon"
            />
          </div>
        </div>
        <strong className="ml-2 flex-1 truncate text-lg font-medium">
          {item.name}
        </strong>
      </div>
      <h2 className="text-xl text-white">Integrations</h2>
      {item.apps_expanded.map((i, index) => (
        <div
          key={index}
          className="flex w-full flex-col gap-3 rounded-lg bg-zinc-900 px-4 py-3"
        >
          <div className="flex items-center gap-2">
            <div
              key={i.image}
              className="flex h-5 w-5 flex-shrink-0 items-center justify-center rounded border border-zinc-300 bg-zinc-100 p-0.5"
            >
              <img src={i.image} alt="Trigger icon" />
            </div>
            <span>{i.label}</span>
          </div>

          {i.triggerPhrase && (
            <div class="flex w-fit items-center rounded-[4px] border border-zinc-700 bg-zinc-800 px-2 py-1 text-sm">
              <span class="font-semibold">Specific Phrase or Keyword</span>: "
              {i.triggerPhrase}"
            </div>
          )}
        </div>
      ))}
      {item.task_description && (
        <p className="text-sm font-normal text-zinc-200">
          Workflow: {item.task_description}
        </p>
      )}
      <h2 className="mt-4 text-xl text-white">Functions</h2>
      {item.functionalities.map((i, index) => (
        <li
          key={index}
          className="rounded-lg bg-zinc-900 px-3 py-1 text-sm text-zinc-300"
        >
          {i}
        </li>
      ))}
    </div>
  );
};

export default TriggerDetails;
